import $ from 'jquery';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';

window.$ = window.jQuery = $;

const body = document.body;

function getTarget(element) {
    const selector = element.getAttribute('data-target') || element.getAttribute('href');

    if (!selector || selector === '#') {
        return null;
    }

    return document.querySelector(selector);
}

function closeOffcanvas(target) {
    if (!target) {
        return;
    }

    target.classList.remove('is-open');
    target.setAttribute('aria-hidden', 'true');

    if (!document.querySelector('.store-offcanvas.is-open')) {
        document.querySelector('.store-offcanvas-backdrop')?.classList.remove('is-open');
        body.classList.remove('store-offcanvas-open');
    }
}

function closeAllOffcanvas() {
    document.querySelectorAll('.store-offcanvas.is-open').forEach((target) => {
        closeOffcanvas(target);
    });
}

function openOffcanvas(target) {
    if (!target) {
        return;
    }

    closeAllOffcanvas();
    target.classList.add('is-open');
    target.setAttribute('aria-hidden', 'false');
    document.querySelector('.store-offcanvas-backdrop')?.classList.add('is-open');
    body.classList.add('store-offcanvas-open');

    if (target.id === 'offcanvas-search') {
        window.setTimeout(() => target.querySelector('#store-search-input')?.focus(), 40);
    }
}

function closeModal(target) {
    if (!target) {
        return;
    }

    target.classList.remove('is-open');
    target.setAttribute('aria-hidden', 'true');
    body.classList.remove('store-offcanvas-open');
}

function openModal(target) {
    if (!target) {
        return;
    }

    target.classList.add('is-open');
    target.setAttribute('aria-hidden', 'false');
    body.classList.add('store-offcanvas-open');
}

function bindStoreControls() {
    document.querySelectorAll('[data-store-offcanvas-toggle]').forEach((toggle) => {
        if (toggle.dataset.storeBound === 'true') {
            return;
        }

        toggle.dataset.storeBound = 'true';
        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            const target = getTarget(toggle);

            if (target?.classList.contains('is-open')) {
                closeOffcanvas(target);
            } else {
                openOffcanvas(target);
            }
        });
    });

    document.querySelectorAll('[data-store-modal-toggle]').forEach((toggle) => {
        if (toggle.dataset.storeBound === 'true') {
            return;
        }

        toggle.dataset.storeBound = 'true';
        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            openModal(getTarget(toggle));
        });
    });

    document.querySelectorAll('[data-store-close]').forEach((close) => {
        if (close.dataset.storeBound === 'true') {
            return;
        }

        close.dataset.storeBound = 'true';
        close.addEventListener('click', (event) => {
            event.preventDefault();
            if (close.classList.contains('store-offcanvas-backdrop')) {
                closeAllOffcanvas();
            } else {
                closeOffcanvas(close.closest('.store-offcanvas'));
            }
            closeModal(close.closest('.store-modal'));
        });
    });

    document.querySelectorAll('[data-toast-close]').forEach((close) => {
        if (close.dataset.storeBound === 'true') {
            return;
        }

        close.dataset.storeBound = 'true';
        close.addEventListener('click', () => {
            const toast = close.closest('#cart-toast');

            if (toast) {
                toast.classList.remove('is-visible');
            }
        });
    });

    document.querySelectorAll('.store-modal').forEach((modal) => {
        if (modal.dataset.storeBound === 'true') {
            return;
        }

        modal.dataset.storeBound = 'true';
        modal.addEventListener('click', (event) => {
            if (event.target === modal) {
                closeModal(modal);
            }
        });
    });

    document.querySelectorAll('[data-store-tab]').forEach((tab) => {
        if (tab.dataset.storeBound === 'true') {
            return;
        }

        tab.dataset.storeBound = 'true';
        tab.addEventListener('click', (event) => {
            event.preventDefault();
            const targetSelector = tab.getAttribute('data-store-tab');
            const group = tab.closest('[data-store-tabs]') || document;

            group.querySelectorAll('[data-store-tab]').forEach((item) => {
                item.classList.toggle('is-active', item === tab);
                item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
            });

            group.querySelectorAll('[data-store-panel]').forEach((panel) => {
                panel.classList.toggle('hidden', `#${panel.id}` !== targetSelector);
            });
        });
    });

    document.querySelectorAll('[data-store-menu-toggle]').forEach((toggle) => {
        if (toggle.dataset.storeBound === 'true') {
            return;
        }

        toggle.dataset.storeBound = 'true';
        toggle.addEventListener('click', () => {
            const target = getTarget(toggle);

            if (!target) {
                return;
            }

            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            target.classList.toggle('hidden', expanded);
        });
    });
}

function bindPasswordToggles() {
    if (document.documentElement.dataset.passwordTogglesBound === 'true') {
        return;
    }

    document.documentElement.dataset.passwordTogglesBound = 'true';
    document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-password-toggle]');

        if (!toggle) {
            return;
        }

        const input = document.getElementById(toggle.getAttribute('data-password-toggle'));

        if (!input) {
            return;
        }

        const visible = input.type === 'password';

        input.type = visible ? 'text' : 'password';
        toggle.setAttribute('aria-pressed', visible ? 'true' : 'false');
        toggle.setAttribute('aria-label', visible ? 'Ukryj hasło' : 'Pokaż hasło');
        toggle.querySelector('[data-password-icon]')?.classList.toggle('hidden', visible);
        toggle.querySelector('[data-password-icon-hidden]')?.classList.toggle('hidden', !visible);
    });
}

function initializeSliders() {
    $('.store-hero-slider').not('.slick-initialized').slick({
        arrows: true,
        dots: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 650,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Poprzedni slajd">←</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Następny slajd">→</button>',
    });

    $('.product-gallery-slider').not('.slick-initialized').slick({
        arrows: true,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.product-thumb-slider',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Poprzednie zdjęcie">←</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Następne zdjęcie">→</button>',
    });

    $('.product-thumb-slider').not('.slick-initialized').slick({
        arrows: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: '.product-gallery-slider',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Poprzednie miniatury">←</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Następne miniatury">→</button>',
    });

    $('.product-carousel').not('.slick-initialized').slick({
        arrows: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Poprzednie produkty">←</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Następne produkty">→</button>',
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 520, settings: { slidesToShow: 1 } },
        ],
    });
}

function initializeGalleries() {
    document.querySelectorAll('[data-pswp-gallery]').forEach((gallery) => {
        if (gallery.dataset.pswpBound === 'true') {
            return;
        }

        gallery.dataset.pswpBound = 'true';
        const lightbox = new PhotoSwipeLightbox({
            gallery,
            children: 'a',
            pswpModule: () => import('photoswipe'),
        });
        lightbox.init();
    });
}

function initializeStorefront() {
    bindStoreControls();
    bindPasswordToggles();
    initializeSliders();
    initializeGalleries();
}

document.addEventListener('DOMContentLoaded', initializeStorefront);
document.addEventListener('livewire:navigated', initializeStorefront);

document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
        return;
    }

    closeAllOffcanvas();
    document.querySelectorAll('.store-modal.is-open').forEach((modal) => closeModal(modal));
});

window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024) {
        closeOffcanvas(document.getElementById('offcanvas-mobile-menu'));
    }
});

function registerLivewireEvents() {
    if (!window.Livewire || window.storeLivewireEventsInitialized) {
        return;
    }

    window.storeLivewireEventsInitialized = true;
    Livewire.on('add-to-cart', () => openOffcanvas(document.getElementById('offcanvas-cart')));
    Livewire.on('showQuickViewModal', () => openModal(document.getElementById('quickViewModal')));
    Livewire.on('showReview', () => openModal(document.getElementById('reviewModal')));
    Livewire.on('cart-toast-show', (message) => {
        const toast = document.getElementById('cart-toast');

        if (!toast) {
            return;
        }

        const payload = message?.detail ?? message;
        const toastMessage = [
            typeof message === 'string' ? message : null,
            payload?.message,
            payload?.[0],
            ...(payload && typeof payload === 'object' ? Object.values(payload) : []),
        ].find((value) => typeof value === 'string' && value.length > 0)
            ?? 'Nie można zwiększyć liczby sztuk tego produktu.';

        toast.querySelector('[data-toast-message]').textContent = toastMessage;
        toast.classList.add('is-visible');
        window.clearTimeout(Number(toast.dataset.timeout));
        toast.dataset.timeout = String(window.setTimeout(() => toast.classList.remove('is-visible'), 8000));
    });
    Livewire.on('updatedProductOptions', initializeStorefront);
    Livewire.hook('morphed', initializeStorefront);
}

document.addEventListener('livewire:init', registerLivewireEvents);
registerLivewireEvents();

function initializeRegistrationPopup() {
    const popup = document.getElementById('popupRegisterBonus');

    if (!popup || document.cookie.includes('popupRegisterBonus=')) {
        return;
    }

    window.setTimeout(() => openModal(popup), 1200);
    popup.addEventListener('click', (event) => {
        if (event.target === popup || event.target.closest('[data-store-close]')) {
            document.cookie = 'popupRegisterBonus=true;max-age=2592000;path=/';
        }
    }, { once: true });
}

document.addEventListener('DOMContentLoaded', initializeRegistrationPopup);
